import type { ProjectGetCommand, SpProjectGetResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertNonEmptyString } from './_utils';

export class GetSpProjectUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectGetCommand): Promise<SpProjectGetResponse> {
    assertNonEmptyString(command.project_id, 'project_id');
    return this.repository.getSpProject(command);
  }
}


